import { Card } from '@mui/material';
import DashboardNavbar from 'components/DashboardNavbar';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import { useEffect, useState } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { Can } from 'context';
import { getSuspiciousSinge } from 'services/suspicious/get-suspicious';
function ShowSuspicious() {
  const { id } = useParams();
  const [data, setData] = useState({});
  useEffect(() => {
    getSuspiciousSinge(id)
      .then((res) => {
        setData(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  return (
    <>
      <Can I='read' a='user'>
        <DashboardLayout>
          <DashboardNavbar />
          <MDBox display='flex' justifyContent='center' width='100%'>
            <Card
              sx={{
                borderRadius: '12px',
                boxShadow: (theme) => theme.shadows[4],
                // width: '50%',
                height: '100%',
                overflow: 'hidden',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                padding: 3
              }}
            >
              <MDBox>
                <MDBox display='flex' justifyContent='space-between' alignItems='center'>
                  <MDTypography variant='h5' fontWeight='medium' textTransform='capitalize'>
                    Id: {data?.id}
                  </MDTypography>
                </MDBox>
                <MDBox display='flex' justifyContent='space-between' alignItems='center'>
                  <MDTypography variant='h5' fontWeight='medium' textTransform='capitalize'>
                    Player: {data?.player ? data.player.username : 'player not found'}
                  </MDTypography>
                </MDBox>
                <MDBox display='flex' justifyContent='space-between' alignItems='center'>
                  <MDTypography variant='h5' fontWeight='medium' textTransform='capitalize'>
                    Action: {data?.action}
                  </MDTypography>
                </MDBox>
                <MDBox display='flex' justifyContent='space-between' alignItems='center'>
                  <MDTypography variant='h5' fontWeight='medium' textTransform='capitalize'>
                    {/* Data: */}
                    {data?.data
                      ? Object?.entries(data?.data)?.map((e) => (
                          <MDBox display='flex' justifyContent='space-between' alignItems='center'>
                            <MDTypography variant='h5' fontWeight='medium' textTransform='capitalize'>
                              {e.join(': ')}
                            </MDTypography>
                          </MDBox>
                        ))
                      : ' no data'}
                  </MDTypography>
                </MDBox>
                <MDBox display='flex' justifyContent='space-between' alignItems='center'>
                  <MDTypography variant='h5' fontWeight='medium' textTransform='capitalize'>
                    Created at: {data?.createdAt}
                  </MDTypography>
                </MDBox>
              </MDBox>
            </Card>
          </MDBox>
        </DashboardLayout>
      </Can>
      <Can not I='read' a='user'>
        <Navigate to='/dashboard' replace />
      </Can>
    </>
  );
}

export default ShowSuspicious;
